import React from "react";
import { ErrorMessage, useField } from "formik";
import { InputProps } from "./Input";

export const TextArea: React.FC<InputProps & {
  errorAbove?: boolean;
  id?: string;
}> = props => {
  const [field, meta] = useField(props.name);
  const wrapClasses = [props?.className];
  if (meta.error) {
    wrapClasses.push("has-error");
  }

  if (meta.touched) {
    wrapClasses.push("touched");
  }

  let above: React.ReactNode = null,
    below: React.ReactNode = (
      <ErrorMessage
        component="div"
        className="error-message"
        name={props.name}
      />
    );

  if (props?.errorAbove) {
    [above, below] = [below, above];
  }

  const id = props.id || `${props.name}-textarea`;

  const classes = [
    "form-control",
    "code",
    props.inputClassName,
    props.disabled ? " disabled" : ""
  ];

  return (
    <div className={`${wrapClasses.filter(c => !!c).join(" ")}`}>
      {above}
      <textarea
        className={classes.filter(c => !!c).join(" ")}
        style={{ width: "100%" }}
        id={id}
        data-testid={id}
        disabled={props.disabled}
        readOnly={props.readOnly}
        {...field}
      />
      {below}
    </div>
  );
};
